var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (false)?_c('RemoveButton',{ref:"removeFromCart",nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.remove.apply(null, arguments)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }